export const OrderGroupStatus = {
	NEW: 1,
	DRIVER_ASSIGNED: 2,
	DELIVERED: 3,
}
